import type { RequestStatus } from '@models/request-status';
import {
    action,
    observable
} from 'mobx';

export interface ISection2ReviewStore {
    readonly loadDetailsRequestStatus: RequestStatus;

    setLoadDetailsRequestStatus(status: RequestStatus): void;
}

export class Section2ReviewStore implements ISection2ReviewStore {
    @observable
    loadDetailsRequestStatus: RequestStatus = 'inactive';

    @action.bound
    setLoadDetailsRequestStatus(status: RequestStatus) {
        this.loadDetailsRequestStatus = status;
    }
}



// WEBPACK FOOTER //
// ./src/stores/onboarding-review/section2-review-store.ts